import dynamic from 'next/dynamic';
// import Error from 'next/error';
const PageNotFound = dynamic(() => import('../../pages/404'));

export const withGetServerSideError = (getServerSideFn) => {
  return async function wrappedGetServerSideProps(ctx) {
    try {
      const result = await getServerSideFn(ctx);
      return result;
    } catch (err) {
      ctx.res.statusCode = 404;
      console.log('err', err);
      const error = {
        statusCode: err.statusCode || 404,
        message: err.message,
      };
      return { props: { error } };
    }
  };
};

// eslint-disable-next-line
export const withError = (Page) => {
  return function WrappedPage(props) {
    const { error } = props;
    if (error) {
      return <PageNotFound />;
    }

    return <Page {...props} />;
  };
};
